<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-product"
      scrollable
      centered
      button-size="sm"
      v-on:hide="aborted"
      v-on:close="aborted"
    >
      <template #modal-title>
        <i class="fas fa-briefcase"></i> ADICIONAR PRODUTO
      </template>
      <div class="pb-4">
        <div class="form-group row pt-2">
          <div class="col-md-12">
            <label for="txtGroup">
              <small
                class="text-danger"
                v-if="form.produtoId.required"
                >*</small
              >
              Produto:
            </label>
            <div class="input-group">
              <span class="input-group-addon">
                <i class="fas fa-briefcase"></i>
              </span>
              <b-form-select
                v-model="form.produtoId.value"
                :options="form.produtoId.options"
              >
                <template slot="first">
                  <option :value="null">
                    {{ $lang.Common.PlaceholderSelect }}
                  </option>
                </template>
              </b-form-select>
            </div>
          </div>
        </div>
        <div
          class="form-group row pt-2"
          v-if="checkTypeBoard(card)"
        >
          <div class="col-md-12">
            <label for="txtGroup">
              <small class="text-danger" v-if="form.operacao.required">*</small>
              Operação:
            </label>

            <div class="input-group">
              <div class="input-group-addon">
                <i class="fas fa-sticky-note"></i>
              </div>

              <v-select
                id="txtGroup"
                v-model="form.operacao.value"
                :options="operacoesPorCpf"
                placeholder="Digite ou selecione uma operação"
                @input="onOperacaoSelecionada"
                :disabled="isEditing"
                :clearable="false"
                :filterable="true"
                :taggable="true"
                :push-tags="true"
                class="flex-grow-1 border-0"
                :menu-class="'dropdown-menu w-100'"
                :searchable="true"
              />
            </div>
          </div>
        </div>
        <div
          class="form-group row pt-2"
          v-if="checkTypeBoard(card)"
        >
          <div class="col-md-6">
            <label for="txtGroup">
              <small
                class="text-danger"
                v-if="form.diasAtraso.required"
                >*</small
              >
              Dias Atraso:
            </label>
            <div class="input-group">
              <span class="input-group-addon">
                <i class="fas fa-clock"></i>
              </span>
              <b-form-input
                type="number"
                placeholder="Dias de Atraso"
                v-model="form.diasAtraso.value"
                :maxlength="form.diasAtraso.maxlength"
                :required="form.diasAtraso.required"
                :state="form.diasAtraso.state"
              ></b-form-input>
            </div>
          </div>
          <div class="col-md-6">
            <label><small class="text-danger">*</small> Risco:</label>
            <div class="input-group">
              <span class="input-group-addon">
                <i class="fas fa-exclamation-circle"></i>
              </span>
              <b-form-input
                type="text"
                placeholder="Risco"
                v-model="form.risco.value"
                :maxlength="form.risco.maxlength"
                :required="form.risco.required"
                :state="form.risco.state"
              ></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
            <div class="col-md-6">
              <label><small class="text-danger">*</small> Valor:</label>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fas fa-coins"></i>
                </span>
                <money
                  :placeholder="$lang.Currency.Placeholder"
                  class="form-control text-bold"
                  style="text-align: right; padding-left: 4px"
                  v-model.lazy="form.valor.value"
                  :required="form.valor.required"
                  :state="form.valor.state"
                  v-bind="$lang.Currency.Format"
                ></money>
              </div>
            </div>
            <div v-if="showFields" class="col-md-6">
              <label><small class="text-danger"></small> Unidade(s):</label>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fas fa-sort-amount-up-alt"></i>
                </span>
                <b-form-input
                  :placeholder="0"
                  class="form-control text-bold"
                  style="text-align: right; padding-left: 4px"
                  v-model.lazy="form.quantidade.value"
                  :required="form.quantidade.required"
                  :state="form.quantidade.state"
                  v-bind="$lang.Currency.Format"
                  type="number"
                ></b-form-input>
              </div>
            </div>
          </div>

        <div v-if="showFields" class="form-group row pt-2">
          <div class="col-md-6">
            <label><small class="text-danger"></small> Quantidade Parcelas:</label>
            <div class="input-group">
              <span class="input-group-addon">
                <i class="fas fa-sort-amount-up-alt"></i>
              </span>
              <b-form-input
                :placeholder="0"
                class="form-control text-bold"
                style="text-align: right; padding-left: 4px"
                v-model.lazy="form.qtdParcelas.value"
                :required="form.qtdParcelas.required"
                :state="form.qtdParcelas.state"
                v-bind="$lang.Currency.Format"
              ></b-form-input>
            </div>
          </div>
          <div v-if="showFields" class="col-md-6">
            <label><small class="text-danger"></small> Valor Parcelas:</label>
            <div class="input-group">
              <span class="input-group-addon">
                <i class="fas fa-coins"></i>
              </span>
              <money
                :placeholder="$lang.Currency.Placeholder"
                class="form-control text-bold"
                style="text-align: right; padding-left: 4px"
                v-model.lazy="form.valorParcelas.value"
                :required="form.valorParcelas.required"
                :state="form.valorParcelas.state"
                v-bind="$lang.Currency.Format"
                readonly
              ></money>
            </div>
          </div>
        </div>
        <div class="form-group row pt-2">
          <div class="col-md-12">
            <label> Observações:</label>
            <b-form-textarea
              v-model="form.observacao.value"
              :placeholder="'Digite a observação aqui'"
              :rows="form.observacao.rows"
              :size="form.observacao.maxlength"
              :noResize="form.observacao.noResize"
            ></b-form-textarea>
            <small class="small-help">
              <i class="fa fa-info-circle"></i>
              <span v-html="FieldSizeTip"></span>.
            </small>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            v-if="eventManager"
            @click.prevent="storeSubmit"
            type="button"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="eventManager.hasNext ? 'Próximo' : 'Salvar'"
          >
            <i
              :class="
                eventManager.hasNext
                  ? 'far fa-arrow-alt-circle-right'
                  : 'fas fa-check-circle'
              "
            ></i>
            <span class="d-md-down-none">
              &nbsp; {{ eventManager.hasNext ? 'Próximo' : 'Salvar' }}
            </span>
          </button>
          <button
            v-else
            @click.prevent="onSave"
            type="button"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Salvar'"
          >
            <i :class="'fas fa-check-circle'"></i>
            <span class="d-md-down-none">&nbsp; Salvar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import CardProductRepository from '@/shared/http/repositories/crm/cardproduct.js'

import { createNewFollowupWithCard } from '@/components/tools/FollowupTools.js'
import BoardRepository from '../../../../../../shared/http/repositories/crm/board.js'
import ModalProductForm from './productmodal-form.js'
import EnumBoardTypes from '../../../../../../enums/enumBoardTypes'

const ModalProductModel = {
  id: null,
  cardId: null,
  produtoId: null,
  valor: '',
  operacao: '',
  diasAtraso: null,
  risco: '',
  data: null,
  observacao: null,
  quantidade: ''
}

export default {
  name: 'ProductModal',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    eventManager: {
      type: Object
    }
  },
  data () {
    return {
      personId: null,
      alreadyPerson: false,
      data: ModalProductModel,
      form: ModalProductForm,
      isEditing: false,
      product: null,
      selected: [],
      operacoesPorCpf: [],
      operacoesDetalhadas: []
    }
  },
  mounted () {
    this.onGetAllProduct()
  },
  watch: {
    'form.qtdParcelas.value' (newVal) {
      this.updateParcelas()
    },
    'form.valor.value' (newVal) {
      this.updateParcelas()
    }
  },
  computed: {
    showFields () {
      return (this.form.valor.value !== '' && this.form.valor.value > 0) && this.card.boardColumn.board.tipoBoard === EnumBoardTypes.VENDA
    }
  },
  methods: {
    onLoad () {},
    showModal (obj) {
      this.data.id = null
      this.form.valor.value = ''
      this.form.quantidade.value = 1
      this.form.qtdParcelas.value = 1
      this.form.valorParcelas.value = ''
      this.form.observacao.value = null
      this.form.produtoId.value = null
      this.form.operacao.value = null
      this.form.diasAtraso.value = null
      this.form.risco.value = null
      this.isEditing = false

      this.selected = ['valor']
      this.$refs['modal-product'].show()

      if (this.card && this.card.pessoa && this.card.pessoa.document) {
        this.getOperacoesByCpf(this.card.pessoa.document)
      }

      if (obj) {
        try {
          loading.push()

          this.data.id = obj.id
          this.form.valor.value = obj.valor
          this.form.quantidade.value = obj.quantidade
          this.form.qtdParcelas.value = obj.qtdParcelas
          this.form.valorParcelas.value = obj.valorParcelas
          this.form.observacao.value = obj.observacao
          this.form.produtoId.value = obj.produtoDTO.id
          this.form.operacao.value = obj.operacao
          this.form.diasAtraso.value = obj.diasAtraso
          this.form.risco.value = obj.risco

          this.isEditing = true
        } catch (e) {
          console.error(e)
        } finally {
          loading.pop()
        }
      }
    },
    hideModal () {
      this.$refs['modal-product'].hide()
      this.$refs['modal-product'].preventDefault()
    },
    destroyComponent () {
      this.$destroy()
    },
    aborted () {
      this.$emit('Abort')
    },
    onGetAllProduct () {
      loading.push()
      BoardRepository.Board_GetAllProducts(this.card.boardColumn.board.id)
        .then((response) => {
          var data = response.data.listaProdutos
          this.form.produtoId.options = data.map((x) => ({
            value: x.id,
            text: x.nome
          }))
          loading.pop()
        })
        .catch(this.onException)
    },
    onFormatData () {
      if (this.data) {
        if (this.form.valor.value && this.form.valor.value !== '') {
          this.data.valor = parseFloat(this.form.valor.value).toFixed(2)
        } else {
          this.data.valor = 0
        }

        this.data.cardId = this.card.id
        this.data.data = this.moment().format('YYYY-MM-DD') + 'T' + this.moment().format('HH:mm:ss')
        this.data.observacao = this.form.observacao.value || ''

        this.data.quantidade = this.form.quantidade.value || null
        this.data.qtdParcelas = this.form.qtdParcelas.value || null
        this.data.valorParcelas = this.form.valorParcelas.value || null
        this.data.operacao = this.form.operacao.value || null
        this.data.diasAtraso = this.form.diasAtraso.value || null
        this.data.risco = this.form.risco.value || null
        this.data.produtoId = this.form.produtoId.value || null

        this.product = this.form.produtoId.options.find(x => x.value === this.data.produtoId)
      }
    },
    storeSubmit () {
      if (!this.form.produtoId.value) {
        toast.error('O campo Produto é obrigatório.')
        return
      }
      if (!this.form.valor.value || parseFloat(this.form.valor.value) <= 0) {
        toast.error('O campo Valor é obrigatório e deve ser maior que zero.')
        return
      }
      this.onFormatData()
      let submit = () => this.onCreate()
      this.$emit('Submit', submit)
    },
    async onCreate () {
      if (!this.eventManager) this.onFormatData()

      await CardProductRepository.Create(this.data)
        .then((response) => {
          if (response.status === 200) {
            createNewFollowupWithCard(
              this.card.pessoa.document,
              'sys_produto_adicionado',
              'O Produto ' + this.product.text + ' foi cadastrado! ',
              this.ip,
              this.latitude,
              this.longitude,
              this.card.id
            )
            this.$emit('Reload')
            if (!this.eventManager) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.hideModal()
            }
          }
          loading.pop()
        })
        .catch((error) => {
          toast.error(
            error.data.errors ? error.data.errors[0].message : '',
            'Não foi possível realizar a operação!'
          )
        })
    },
    async onUpdate () {
      this.onFormatData()
      await CardProductRepository.Update(this.data)
        .then((response) => {
          if (response.status === 200) {
            let product = this.form.produtoId.options.find(
              (x) => x.value === this.data.produtoId
            )
            createNewFollowupWithCard(
              this.card.pessoa.document,
              'sys_produto_editado',
              'O Produto ' + product.text + ' foi atualizado!',
              this.ip,
              this.latitude,
              this.longitude,
              this.card.id
            )
            this.$emit('Reload')
            toast.success(this.$lang.Common.Alerts.Success)
            let create = () => this.onCreate()
            this.$emit('Submit', create)
          }
          loading.pop()
        })
        .catch(this.onException)
        .finally(() => {
          this.hideModal()
        })
    },
    checkTypeBoard (card) {
      if (
        card &&
        (card.boardColumn.board.tipoBoard === 'COBRANCA' ||
          card.boardColumn.board.tipoBoard === 'AJUIZAMENTO')
      ) {
        return true
      }
      return false
    },
    updateParcelas () {
      if (this.form.qtdParcelas.value > 1) {
        this.form.valorParcelas.value = this.form.valor.value / this.form.qtdParcelas.value
      } else {
        this.form.valorParcelas.value = this.form.valor.value
      }
    },
    getOperacoesByCpf (cpf) {
      CardProductRepository.SearchOperations({ cpf })
        .then(response => {
          this.operacoesDetalhadas = response.data || []
          this.operacoesPorCpf = this.operacoesDetalhadas.map(item => item.operacao)
        })
        .catch(() => {
          this.operacoesPorCpf = []
          this.operacoesDetalhadas = []
        })
    },
    onOperacaoSelecionada (operacaoSelecionada) {
      const operacao = this.operacoesDetalhadas.find(op => op.operacao === operacaoSelecionada)
      console.log(operacao)
      if (operacao) {
        this.form.valor.value = operacao.valor
        this.form.risco.value = operacao.risco
        this.form.produtoId.value = operacao.produtoDTO.id
        this.form.diasAtraso.value = operacao.diasAtraso

        this.showFields = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/product/modal/productmodal.vue